import React from 'react';
import withSideEffect from 'react-side-effect';
var INITIAL_CODE = -1;
var PROP_NAME = 'code';
var StatusCodeComponent = function StatusCodeComponent(_ref) {
  var children = _ref.children;
  return React.createElement(React.Fragment, null, children);
};
export var reducePropsToState = function reducePropsToState(props) {
  return props.map(function (x) {
    return x[PROP_NAME];
  }).filter(function (x) {
    return x !== null && typeof x !== 'undefined';
  }).reduce(function (state, code) {
    return Math.max(state, code);
  }, INITIAL_CODE);
};
export var StatusCode = withSideEffect(reducePropsToState, function () {
  return undefined;
})(StatusCodeComponent);